//Librerie
import { useTranslation } from "react-i18next";

const Ticker: React.FC = () => {

    const { t } = useTranslation();
    const tickerElements = [ 
        t('homePage.hero.ticker.element1'),
        t('homePage.hero.ticker.element2'),
        t('homePage.hero.ticker.element3'),
        t('homePage.hero.ticker.element1'),
        t('homePage.hero.ticker.element2'),
        t('homePage.hero.ticker.element3'),
    ]

    return(
        <div id="ticker">
            <div className="ticker-text-wrapper d-flex">
                {tickerElements.map((element, index) => (
                    <div key={index} className="d-flex">
                        <p className="mb-0 px-4 px-lg-5">{element}</p>
                        <span className="px-4 px-lg-5">///</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Ticker;